export class AppVersion {
    public static readonly Version = "672(90b1689f)";
    public static readonly CommitHash = 'unknown';
}